import dayjs from 'dayjs';
import { groupBy, unionBy, sortBy } from 'lodash';
import { getEpicIssueTypeList, getRoadmapRelationship } from '@/api/roadmap';

const DAY_WIDTH = {
  month: 10,
  week: 40,
  quarter: 4
};
export default {
  namespaced: true,
  state: {
    epicList: [],
    scrollTop: 0, // 同步左右滚动条
    scrollLeft: 0,
    hoverKey: null,
    dateRange: ['2019/01/01 00:00:00', '2026/12/31 11:59:59'],
    expands: [],
    isDraging: false,
    dateType:'',
    epicIssueObj:{},
    addKey: null,
    orderBy: {},
    shouldUpdateItems: [],
    hightLightItem: {},
    filterSelected: {},
    shouldAnimation: false,
    projectEpicIssueTypeMap: {},
    horizontalScrollerClass: 'zk-gantt-horizontal-scroller',
    lineDragging: false,
    projectViewLoadedRelationshipObj: {
      epic: {}
    },
    relationShipDataList: [],
    currentDragSourceId: null,
    verticalScrollerClass: 'zk-gantt-vertical-scroller',
    holidays: null
  },
  getters:{
    dayCellWidth(state) {
      return DAY_WIDTH[state.dateType];
    },
    dateRowWidth(state, getters) {
      return getters.headerList.reduce((pre, cur) => pre + cur.width, 0);
    },
    isExpand(state) {
      return key => {
        return state.expands.includes(key);
      };
    },
    isExpandAll(state) {
      return state.expands.length === state.epicList.length;
    },
    dateList(state) {
      if (!state.dateRange.length){
        return [];
      }
      const [start, end] = state.dateRange;
      const list = createDateList(start, end);
      return list;
    },
    headerList(state, getters) {
      if (!getters.dateList.length){
        return [];
      }
      if (!state.dateType){
        return [];
      }
      const dateList = getters.dateList;
      const groupByDateType = groupBy(dateList, `year_${state.dateType}`);
      const list = Object.keys(groupByDateType).map(
        key =>{
          const firstItem = groupByDateType[key][0];
          return Object.freeze({
            ...firstItem,
            width: groupByDateType[key].length * getters.dayCellWidth
          });
        }
      );
      return Object.freeze(list);
    },
    list(state) {
      const list = [...state.epicList];
      state.expands?.forEach(key => {
        const index = list.findIndex(item => item.key === key);
        if (index !== -1 && state.epicIssueObj[key]?.length){
          list.splice(index + 1, 0, ...state.epicIssueObj[key]);
        }
      });
      if (state.addKey) {
        const index = list.findIndex(item => item.key === state.addKey);
        if (index !== -1){
          list.splice(index + 1, 0, {
            type: 'add',
            size: 46,
            id: list[index].id,
            epicId: list[index].id,
            key: list[index].key,
            uid: `${list[index].key}_add`
          });
        }
      }
      // 提前将每行距离顶部的高度计算好
      let height = 0;
      for (let i = 0; i < list.length; i++){
        list[i] = Object.freeze({ ...list[i], top: height });
        height = height + list[i].size;
      }
      return Object.freeze(list);
    },
    currentRelationDataObj(state) {
      const dataObj = state.projectViewLoadedRelationshipObj.epic;
      const res = [];
      if (dataObj && typeof dataObj === 'object') {
        Object.keys(dataObj)?.forEach(id => {
          const issueIdRelationMap = dataObj[id]?.issueIdRelationMap;
          if (issueIdRelationMap && typeof issueIdRelationMap === 'object') {
            return Object.keys(issueIdRelationMap)?.forEach(issueId => {
              return res.push(issueIdRelationMap[issueId]);
            });
          }
        });
        return res.flat();
      }
      return [];
    }
  },
  mutations: {
    SET_HOLIDAYS(state, holidays){
      state.holidays = holidays || new Set();
    },
    TOGGLE_EXPAND_ALL(state, isExpandAll) {
      state.expands = isExpandAll ? state.epicList.map(item => item.key) : [];
    },
    SET_EXPANDS(state, expands) {
      state.expands = expands;
    },
    SET_SCROLLTOP(state, scrollTop) {
      state.scrollTop = scrollTop;
    },
    SET_SCROLLLEFT(state, scrollLeft) {
      state.scrollLeft = scrollLeft;
    },
    SET_ELEMENT_SCROLLLEFT(state, { scrollLeft, smooth }){
      const el = document.querySelector(`.${state.horizontalScrollerClass}`);
      if (!el){
        return;
      }
      el.scrollTo({ left: scrollLeft, behavior: smooth ? 'smooth' : undefined });
    },
    SET_HOVER(state, key) {
      state.hoverKey = key;
    },
    SET_ORDER_BY(state, data = {}) {
      state.orderBy = { ...data };
    },
    CLEAR_STATE(state) {
      state.scrollLeft = 0;
      //state.scrollTop = 0;
      //state.expands = [];
      state.addKey = null;
      //state.epicIssueObj = {};
      state.hoverKey = null;
      state.projectViewLoadedRelationshipObj = Object.assign({}, state.projectViewLoadedRelationshipObj, {
        epic: {}
      });
      //state.epicList = [];
      //state.shouldUpdateItems = [];
    },
    SET_LIST(state, list) {
      state.epicList = list.map(item =>Object.freeze({
        ...item,
        type: 'epic',
        key: item.id,
        name: item.summary,
        iconUrl: 'iconshishi',
        level: 0,
        size: 50,
        showTimebar: true,
        editTimebar: true,
        startDate: item.startDate || item.dueDate,
        endDate: item.dueDate || item.startDate,
        reallyDate: [item.startDate, item.dueDate],
        uid: `epic_${item.id}`,
        epicId: item.id,
        path: 'project.epic',
        pathId: `${this.state.app.currentProject}.${item.id}`
      }));
    },
    TOGGLE_EXPAND(state, key) {
      if (!key) {
        return;
      }
      const index = state.expands.indexOf(key);
      if (index === -1){
        state.expands.push(key);
      } else {
        state.expands.splice(index, 1);
      }
    },
    SET_IS_DRAGING(state, value) {
      state.isDraging = value;
    },
    SET_DATE_TYPE(state, value){
      state.dateType = value;
    },
    SET_DATE_RANGE(state, value){
      state.dateRange = value || [];
    },
    SET_EPIC_ISSUES(state, payload){
      let list = payload.value?.map(item => ({
        ...item,
        type: 'issue',
        key: item.id,
        name: item.summary,
        level: 1,
        size: 40,
        showTimebar: true,
        editTimebar: true,
        startDate: item.startDate || item.dueDate,
        endDate: item.dueDate || item.startDate,
        reallyDate: [item.startDate, item.dueDate],
        uid: `issue_${item.id}`,
        epicId: payload.epicId,
        path: 'project.epic.issue',
        pathId: `${this.state.app.currentProject}.${payload.epicId}.${item.id}`
      }));
      if (payload.keepOld){
        const oldList = state.epicIssueObj[payload.epicId];
        const keepStickList = oldList.filter(item => item.isKeepStick);
        if (oldList?.length){
          const newIds = list.map(item => item.id);
          list = unionBy(list, oldList, 'id').map(
            item => Object.freeze({
              ...item,
              isKeepOld: !newIds.includes(item.id),
              keepKey: 'filter'
            })
          );
        }
        if (keepStickList.length){
          const stickIds = keepStickList.map(item => item.id);
          const data = groupBy(list, item => stickIds.includes(item.id) ? 'stick' : 'notStick');
          const stickGroupList = data.stick || [];
          const notStickGroupList = data.notStick || [];
          let stickList = stickGroupList.map(item => ({ ...item, isKeepStick: true, isKeepOld: true, keepKey: 'sort' }));
          stickList = sortBy(stickList, item => stickIds.indexOf(item.id));
          list = [...stickList, ...notStickGroupList];
        }
      }
      state.epicIssueObj = {
        ...state.epicIssueObj,
        [payload.epicId]: list
      };
    },
    SET_ADD_KEY(state, value){
      state.addKey = value;
    },
    SET_UPDATE_ITEMS(state, data) {
      state.shouldUpdateItems = data || [];
    },
    UPDATE_EPIC_COUNT(state, payload){
      const list = state.epicList;
      const index = list.findIndex(item => item.uid === `epic_${payload.epicId}`);
      if (index !== -1){
        list.splice(index, 1, {
          ...list[index],
          ...payload.value
        });
      }
    },
    UPDATE_ISSUE(state, payload){
      const { type, epicId, id, value } = payload;
      if (type === 'epic'){
        const list = state.epicList;
        const index = list.findIndex(item => item.uid === `epic_${id}`);
        if (index !== -1){
          list.splice(index, 1, {
            ...list[index],
            ...value
          });
        }
      }
      if (type === 'issue'){
        const list = state.epicIssueObj[epicId];
        const index = list.findIndex(item => item.uid === `issue_${id}`);
        if (index !== -1){
          list.splice(index, 1, {
            ...list[index],
            ...payload.value
          });
          state.epicIssueObj = {
            ...state.epicIssueObj,
            [epicId]: list
          };
        }
      }
    },
    ADD_LOCAL_ISSUE(state, payload){
      const { epicId } = payload;
      if (!epicId){
        return;
      }
      const list = state.epicIssueObj[epicId];
      list.unshift(payload);
      state.epicIssueObj = {
        ...state.epicIssueObj,
        [epicId]: list
      };
    },
    SET_HIGHT_LIGHT_ITEM(state, value){
      state.hightLightItem = value;
    },
    SET_ANIMATION(state, value){
      state.shouldAnimation = value;
      if (value){
        setTimeout(() => {
          state.shouldAnimation = false;
        }, 2000);
      }
    },
    SET_PROJECT_EPIC_ISSUE_TYPE_MAP(state, value){
      if (!value){
        return;
      }
      state.projectEpicIssueTypeMap = {
        ...state.projectEpicIssueTypeMap,
        ...value
      };
    },
    SET_FILTER_SELECTED(state, data) {
      state.filterSelected = { ...data };
    },
    SET_LINE_DRAGGING(state, value) {
      state.lineDragging = value;
    },
    SET_PROJECT_LOADED_RELATIONSHIP(state, data) {
      state.projectViewLoadedRelationshipObj = {
        ...state.projectViewLoadedRelationshipObj,
        ...data
      };
    },
    SET_RELATIONSHIP_DATA(state, value) {
      state.relationShipDataList = value;
    },
    SET_CURRENT_DRAG_ITEM(state, value) {
      state.currentDragSourceId = value;
    }
  },
  actions:{
    setPosition({ commit, getters, state }, { direction, source }) {
      const el = document.querySelector(`.${state.horizontalScrollerClass}`);
      if (!el || !direction || !source){
        return;
      }
      const boundWidth = el.getBoundingClientRect().width;
      const scrollLeft = state.scrollLeft;
      const firstDate = getters.dateList[0].date;
      const dayCellWidth = getters.dayCellWidth;
      const boundLeftDays = Math.round(scrollLeft / dayCellWidth);
      const boundRightDays = Math.round((scrollLeft + boundWidth) / dayCellWidth);
      const start = dayjs(firstDate).add(boundLeftDays, 'day').format('YYYY/MM/DD');
      const end = dayjs(firstDate).add(boundRightDays, 'day').format('YYYY/MM/DD');
      const { startDate, endDate } = source;
      let distance = 0;
      const padding = 50;
      if (direction === 'left'){
        distance = -getDiffDays(startDate, start) * dayCellWidth - padding;
      }
      if (direction === 'right'){
        distance = (getDiffDays(end, endDate) + 1) * dayCellWidth + padding;
      }
      commit('SET_ELEMENT_SCROLLLEFT', { scrollLeft: scrollLeft + distance, smooth: true });
    },
    async loadIssueTypes({ commit }, projectId) {
      if (!projectId){
        return;
      }
      const result = await getEpicIssueTypeList(projectId);
      commit('SET_PROJECT_EPIC_ISSUE_TYPE_MAP', ({ [projectId]: result || [] }));
    },
    async getRelationshipInfos({ commit, state }, { path, pathId }) {
      const view = path.split('.')[0];
      const item = path.split('.')[1];
      const pathIds = String(pathId)
        ?.split('.')
        ?.map(id => +id);
      const idParams = {
        [`${view}Id`]: pathIds[0],
        [`${item}Id`]: pathIds[1]
      };
      const result = await getRoadmapRelationship({
        ...idParams
      });
      commit('SET_PROJECT_LOADED_RELATIONSHIP', {
        epic: {
          ...state.projectViewLoadedRelationshipObj.epic,
          [`${idParams.projectId}.${[idParams.epicId]}`]: result
        }
      });
    }
  }
};

function createDateList(start, end){
  const list = [];
  const diff = dayjs(end).diff(start, 'day');
  for (let i = 0; i <= diff; i++) {
    const date = dayjs(start)
      .add(i, 'day');
    list.push(createDateItem(date));

  }
  return Object.freeze(list);
}

function createDateItem(date){
  const month = dayjs(date).month();
  const year = dayjs(date).year();
  const week = dayjs(date).week();
  const quarter = dayjs(date).quarter();
  let weekYear = year;
  // 周跨年时候处理
  if (month === 0 && week > 10){
    weekYear--;
  }
  if (month === 11 && week === 1){
    weekYear++;
  }
  return Object.freeze({
    date: dayjs(date).format('YYYY/MM/DD 00:00:00'),
    month,
    year,
    quarter,
    week,
    year_month: `${year}_${month}`,
    year_week: `${weekYear}_${week}`,
    year_quarter: `${year}_${quarter}`
  });
}

function getDiffDays(start, end) {
  if (!(start && end)) {
    return;
  }
  const startDate = dayjs(start).format('YYYY-MM-DD');
  const endDate = dayjs(end).format('YYYY-MM-DD');
  return dayjs(endDate).diff(startDate, 'day', true);
}
